import { render } from "./enrolmentStep3_2.vue?vue&type=template&id=fa402a0e&scoped=true"
import script from "./enrolmentStep3_2.vue?vue&type=script&lang=js"
export * from "./enrolmentStep3_2.vue?vue&type=script&lang=js"

import "./enrolmentStep3_2.vue?vue&type=style&index=0&id=fa402a0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa402a0e"]])

export default __exports__